import { useMutation } from "@tanstack/react-query";
import { PanelAddParams, panelAdd } from "common/api/sakusas/sakusas_panel";
import { useInvalidateQueryByKeys } from "hooks/query_common/useInvalidateQueryByKeys";

type UseSakusasPanelAddParams = {
  invalidateKeys?: string[];
  successHandle?: Function;
};

export const useSakusasPanelAdd = (hookParams?: UseSakusasPanelAddParams) => {
  const { invalidateQueriesByKeys } = useInvalidateQueryByKeys();
  const { mutate: panelAddMutate } = useMutation({
    mutationFn: async (panelAddParams: PanelAddParams) =>
      await panelAdd(panelAddParams),
    onSuccess: (response) => {
      if (hookParams?.invalidateKeys) {
        invalidateQueriesByKeys(hookParams.invalidateKeys);
      }
      if (hookParams?.successHandle) {
        hookParams.successHandle(response);
      }
    },
  });

  return { panelAddMutate };
};
